import { render } from "./customers-details.vue?vue&type=template&id=12b26f91&scoped=true"
import script from "./customers-details.vue?vue&type=script&lang=js"
export * from "./customers-details.vue?vue&type=script&lang=js"

import "./customers-details.vue?vue&type=style&index=0&id=12b26f91&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b26f91"]])

export default __exports__